import Api from "../api";
let uri = '/api/ed/tutorial';

export const getTutorial = () => {
    return Api.getInstance().executeGetQuery(`${uri}`)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const adminTutorial = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}



